import { render, staticRenderFns } from "./UploadReqs.vue?vue&type=template&id=567bf9cf&scoped=true&"
import script from "./UploadReqs.vue?vue&type=script&lang=js&"
export * from "./UploadReqs.vue?vue&type=script&lang=js&"
import style0 from "./UploadReqs.vue?vue&type=style&index=0&id=567bf9cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567bf9cf",
  null
  
)

export default component.exports